<template lang="html">
  <button class="pv2 ph2 br2 bn pointer">
    <span class="flex items-center"
      :class="{
        'justify-between': iconCode,
        'justify-center': !iconCode
      }"
    >
      <i v-if="iconPos === 'left' && iconCode"
        class="material-icons"
        :class="[{ 'mr2': label }, iconClass ]"
      >{{ iconCode }}</i>
      <span v-if="label"
        class="h1"
        :class="{
          'mr2': iconPos === 'left' && iconCode,
          'ml2': iconPos === 'right' && iconCode,
          'mh2': !iconCode
        }"
      >{{ label }}</span>
      <i v-if="iconPos === 'right' && iconCode"
        class="material-icons"
        :class="[{ 'ml2': label }, iconClass]"
      >{{ iconCode }}</i>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    iconCode: {
      type: String,
      default: ''
    },
    iconPos: {
      type: String,
      default: 'left'
    },
    iconClass: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss">
// .material-icons {
//   font-size: inherit;
// }
</style>



// WEBPACK FOOTER //
// src/components/Button.vue